/* ════════════════════════════════════════════
   Nude Project Theme — Mega Menu JavaScript
   ════════════════════════════════════════════ */

(function() {
  'use strict';

  const header = document.querySelector('[data-header]');
  if (!header) return;

  // ─── Mega Menu ───
  const triggers = header.querySelectorAll('[data-mega-menu-trigger]');
  const menus = header.querySelectorAll('[data-mega-menu]');
  let activeMenu = null;
  let closeTimeout = null;

  function openMenu(menuId) {
    clearTimeout(closeTimeout);
    menus.forEach(function(menu) {
      const isTarget = menu.getAttribute('data-mega-menu') === menuId;
      menu.classList.toggle('is-active', isTarget);
      menu.setAttribute('aria-hidden', !isTarget);
    });
    activeMenu = menuId;
  }

  function closeAllMenus() {
    closeTimeout = setTimeout(function() {
      menus.forEach(function(menu) {
        menu.classList.remove('is-active');
        menu.setAttribute('aria-hidden', 'true');
      });
      activeMenu = null;
    }, 150);
  }

  triggers.forEach(function(trigger) {
    var menuId = trigger.getAttribute('data-mega-menu-trigger');

    trigger.addEventListener('mouseenter', function() {
      openMenu(menuId);
    });

    trigger.addEventListener('mouseleave', function() {
      closeAllMenus();
    });

    trigger.addEventListener('focus', function() {
      openMenu(menuId);
    });
  });

  menus.forEach(function(menu) {
    menu.addEventListener('mouseenter', function() {
      clearTimeout(closeTimeout);
    });

    menu.addEventListener('mouseleave', function() {
      closeAllMenus();
    });
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activeMenu) {
      menus.forEach(function(menu) {
        menu.classList.remove('is-active');
        menu.setAttribute('aria-hidden', 'true');
      });
      activeMenu = null;
    }
  });

  // ─── Desktop Shop Dropdown ───
  var shopTrigger = document.querySelector('[data-shop-dropdown-trigger]');
  var shopDropdown = document.querySelector('[data-shop-dropdown]');
  var shopCloseTimeout = null;

  function openShopDropdown() {
    clearTimeout(shopCloseTimeout);
    if (!shopDropdown) return;
    shopDropdown.classList.add('is-active');
    shopDropdown.setAttribute('aria-hidden', 'false');
    if (header) header.classList.add('is-active');
  }

  function closeShopDropdown() {
    shopCloseTimeout = setTimeout(function() {
      if (!shopDropdown) return;
      shopDropdown.classList.remove('is-active');
      shopDropdown.setAttribute('aria-hidden', 'true');
      if (header && !header.matches(':hover')) {
        // Don't remove is-active if the header is meant to be white always (relative state)
        if (!header.classList.contains('header--relative')) {
          header.classList.remove('is-active');
        }
      }
    }, 120);
  }

  if (shopTrigger) {
    shopTrigger.addEventListener('mouseenter', openShopDropdown);
    shopTrigger.addEventListener('mouseleave', closeShopDropdown);
  }

  if (shopDropdown) {
    shopDropdown.addEventListener('mouseenter', function() { clearTimeout(shopCloseTimeout); });
    shopDropdown.addEventListener('mouseleave', closeShopDropdown);
  }

  // ─── Desktop Collections Dropdown ───
  var collectionsTrigger = document.querySelector('[data-collections-dropdown-trigger]');
  var collectionsDropdown = document.querySelector('[data-collections-dropdown]');
  var collectionsCloseTimeout = null;

  function openCollectionsDropdown() {
    clearTimeout(collectionsCloseTimeout);
    if (!collectionsDropdown) return;
    collectionsDropdown.classList.add('is-active');
    collectionsDropdown.setAttribute('aria-hidden', 'false');
    if (header) header.classList.add('is-active');
  }

  function closeCollectionsDropdown() {
    collectionsCloseTimeout = setTimeout(function() {
      if (!collectionsDropdown) return;
      collectionsDropdown.classList.remove('is-active');
      collectionsDropdown.setAttribute('aria-hidden', 'true');
      if (header && !header.matches(':hover')) {
        // Don't remove is-active if the header is meant to be white always (relative state)
        if (!header.classList.contains('header--relative')) {
          header.classList.remove('is-active');
        }
      }
    }, 120);
  }

  if (collectionsTrigger) {
    collectionsTrigger.addEventListener('mouseenter', openCollectionsDropdown);
    collectionsTrigger.addEventListener('mouseleave', closeCollectionsDropdown);
  }

  if (collectionsDropdown) {
    collectionsDropdown.addEventListener('mouseenter', function() { clearTimeout(collectionsCloseTimeout); });
    collectionsDropdown.addEventListener('mouseleave', closeCollectionsDropdown);
  }

  // ─── Mobile Menu ───
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileClose = document.querySelector('[data-mobile-menu-close]');
  var overlay = document.querySelector('[data-overlay]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-active');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    if (header) header.classList.add('is-menu-open');
    // Disable overlay for mobile menu
    window.dispatchEvent(new Event('scroll'));
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-active');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (header) header.classList.remove('is-menu-open');
    // Disable overlay for mobile menu
    window.dispatchEvent(new Event('scroll'));
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function() {
      if (mobileMenu.classList.contains('is-active')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  if (mobileClose) {
    mobileClose.addEventListener('click', closeMobileMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', function() {
      closeMobileMenu();
      // Also close cart drawer if open
      var cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-active');
        cartDrawer.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('no-scroll');
      overlay.classList.remove('is-active');
    });
  }

  // ─── Mobile Accordion ───
  var accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
  accordionToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var section = toggle.closest('[data-accordion]');
      if (!section) return;
      var isOpen = section.classList.contains('is-open');

      // Close all others in the group
      var group = toggle.closest('[data-accordion-group]');
      if (group) {
        group.querySelectorAll('[data-accordion]').forEach(function(acc) {
          if (acc !== section) {
            acc.classList.remove('is-open');
            var otherToggle = acc.querySelector('[data-accordion-toggle]');
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          }
        });
      }

      if (isOpen) {
        section.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        section.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ─── Search Overlay ───
  var searchToggles = document.querySelectorAll('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchClose = document.querySelector('[data-search-close]');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-active');
    searchOverlay.setAttribute('aria-hidden', 'false');
    if (header) header.classList.add('is-search-open');
    if (searchInput) {
      setTimeout(function() { searchInput.focus(); }, 100);
    }
    window.dispatchEvent(new Event('scroll'));
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-active');
    searchOverlay.setAttribute('aria-hidden', 'true');
    if (header) header.classList.remove('is-search-open');
    if (searchInput) searchInput.value = '';
    window.dispatchEvent(new Event('scroll'));
  }

  searchToggles.forEach(function(toggle) {
    toggle.addEventListener('click', openSearch);
  });

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileMenu();
    }
  });

})();
